export default __webpack_public_path__ + "static/media/lionthumb.cbb7b2b2.png";